module.exports = __webpack_public_path__ + "media/images/favicons/tastee-society/android-chrome-192x192-3b00d0d5035e1305e475f9b1923be34e.png";